import React, { useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
/**********************Componentes Especificos**************************************** */
import IngresosQuimicosyColorantesEnc from './Tabs/IngresosQuimicosyColorantesEnc'

const IngresosQuimicosYColorantesScreen = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    return (
        <TabView className="col-12 homeTabView" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel header='Encabezado'>
                <IngresosQuimicosyColorantesEnc />
            </TabPanel>
        </TabView>
    )
}

export default IngresosQuimicosYColorantesScreen